export const apiStatus = {
    Idle:       Symbol("IDLE"),
    Pending:    Symbol("PENDING"),
    Success:    Symbol("SUCCESS"),
    Error:      Symbol("ERROR")
}